<table mat-table [dataSource]="toleranceData">
  <ng-container matColumnDef="colorSystem">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let element" class="no-wrap"> {{ element.colorSystem }} </td>
  </ng-container>
  <ng-container matColumnDef="geo">
    <th mat-header-cell *matHeaderCellDef>Geo</th>
    <td mat-cell *matCellDef="let element" class="no-wrap"> {{ element.angle }} </td>
  </ng-container>
  <ng-container matColumnDef="lowL">
    <th mat-header-cell *matHeaderCellDef>-T<sub>L</sub></th>
    <td mat-cell *matCellDef="let element" class="no-wrap">
      @if (element.lowerDl !== null) {
        <span>
          {{ element.lowerDl | number:'1.2-2' }}
        </span>
      }
    </td>
  </ng-container>
  <ng-container matColumnDef="L">
    <th mat-header-cell *matHeaderCellDef>+T<sub>L</sub></th>
    <td mat-cell *matCellDef="let element" class="no-wrap">
      @if (element.dl !== null) {
        <span>
          {{ element.dl | number:'1.2-2' }}
        </span>
      }
    </td>
  </ng-container>
  <ng-container matColumnDef="lowAC">
    <th mat-header-cell *matHeaderCellDef>-T<sub>a/C</sub></th>
    <td mat-cell *matCellDef="let element" class="no-wrap">
      @if (element.colorSystem === 'LAB' && element.lowerDa !== null) {
        <span>
          {{ element.lowerDa | number:'1.2-2' }}
        </span>
      }
      @if (element.colorSystem === 'LCH' && element.lowerDc !== null) {
        <span>
          {{ element.lowerDc | number:'1.2-2' }}
        </span>
      }
    </td>
  </ng-container>
  <ng-container matColumnDef="AC">
    <th mat-header-cell *matHeaderCellDef>+T<sub>a/C</sub></th>
    <td mat-cell *matCellDef="let element" class="no-wrap">
      @if (element.colorSystem === 'LAB' && element.da !== null) {
        <span>
          {{ element.da | number:'1.2-2' }}
        </span>
      }
      @if (element.colorSystem === 'LCH' && element.dc !== null) {
        <span>
          {{ element.dc | number:'1.2-2' }}
        </span>
      }
    </td>
  </ng-container>
  <ng-container matColumnDef="lowBH">
    <th mat-header-cell *matHeaderCellDef>-T<sub>b/H</sub></th>
    <td mat-cell *matCellDef="let element" class="no-wrap">
      @if (element.colorSystem === 'LAB' && element.lowerDb !== null) {
        <span>
          {{ element.lowerDb | number:'1.2-2' }}
        </span>
      }
      @if (element.colorSystem === 'LCH' && element.lowerDh !== null) {
        <span>
          {{ element.lowerDh | number:'1.2-2' }}
        </span>
      }
    </td>
  </ng-container>
  <ng-container matColumnDef="BH">
    <th mat-header-cell *matHeaderCellDef>+T<sub>b/H</sub></th>
    <td mat-cell *matCellDef="let element" class="no-wrap">
      @if (element.colorSystem === 'LAB' && element.db !== null) {
        <span>
          {{ element.db | number:'1.2-2' }}
        </span>
      }
      @if (element.colorSystem === 'LCH' && element.dh !== null) {
        <span>
          {{ element.dh | number:'1.2-2' }}
        </span>
      }
    </td>
  </ng-container>
  @if (!(specialColoring)) {
    <div>
      <ng-container matColumnDef="dEGreen">
        <th mat-header-cell *matHeaderCellDef>green</th>
        <td mat-cell *matCellDef="let element" class="no-wrap">
          @if (element.lowerDe !== null) {
            <span>
              {{ element.lowerDe | number:'1.2-2' }}
            </span>
          }
        </td>
      </ng-container>
      <ng-container matColumnDef="dERed">
        <th mat-header-cell *matHeaderCellDef>red</th>
        <td mat-cell *matCellDef="let element" class="no-wrap">
          @if (element.de !== null) {
            <span>
              {{ element.de | number:'1.2-2' }}
            </span>
          }
        </td>
      </ng-container>
    </div>
  }
  <ng-container matColumnDef="tableTitle">
    <th mat-header-cell [colSpan]="8" *matHeaderCellDef class="centered-header">{{ tableTitle }}</th>
  </ng-container>
  <ng-container matColumnDef="limitsDE">
    <th mat-header-cell [colSpan]="2" *matHeaderCellDef>Limits &lt;dE&gt;</th>
  </ng-container>
  <tr mat-header-row *matHeaderRowDef="headerColumns;"></tr>
  <tr mat-header-row class="border-line-bottom" *matHeaderRowDef="displayedColumns;"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  <tr class="mat-row" *matNoDataRow>
    <td class="mat-cell" [attr.colspan]="displayedColumns.length">
      {{ 'notification.noData' | translate }}
    </td>
  </tr>
</table>
